import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { routerPath } from '../../router/routerPath';
import { logout } from '../../store/authStore/auth.action';
import { authContext } from '../../store/authStore/AuthContext';
import { LkNavbarContainer } from './styled';

export const LkNavbar = () => {
  const { dispatch } = useContext(authContext);
  const navigate = useNavigate();

  return (
    <LkNavbarContainer>
      <div className="side-block">
        <Link to="/">Федеральный перечень учебников</Link>
      </div>
      <button
        className="side-block"
        onClick={() => {
          dispatch(logout());
          navigate(routerPath.home);
        }}
      >
        Выход
      </button>
    </LkNavbarContainer>
  );
};
